module.exports = __webpack_public_path__ + "img/stock5.ebeee67f.png";